import React from 'react'
import TitleContext from 'contexts/Title'

export default function useTitle() {
  return React.useContext(TitleContext)
}